'use client'

import { Typography } from '@mui/material'

// Types
import type { TypographyProps } from '@/types/components/atoms/typography'

const ParagraphTypographyAtom = (props: TypographyProps) => {
	// Props
	const { text } = props

	return <Typography variant="body2">{text}</Typography>
}

export default ParagraphTypographyAtom
